import { StudentLecturesComponent } from './student-lectures/student-lectures.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StudentsComponent } from './students.component';
import { ButtonModule } from 'primeng/button';
import { TabViewModule } from 'primeng/tabview';
import {
  FasServiceDynamicTableComponent,
  FasServiceTableComponent,
} from 'fas-services';
import { AddStudentComponent } from './add-student/add-student.component';
import { StudentsDetailsComponent } from './students-details/students-details.component';
import { InviteStudentComponent } from './invite-student/invite-student.component';
import { ExamViewComponent } from './exam-view/exam-view.component';
import { ExamDateComponent } from './exam-date/exam-date.component';
import { StudentsListActiveComponent } from './students-list-active/students-list-active.component';
import { StudentsListArchivedComponent } from './students-list-archived/students-list-archived.component';
import { SubscriptionTagComponent } from '../../shared/components/subscription-tag/subscription-tag.component';
import { DialogModule } from 'primeng/dialog';
import { StepperModule } from 'primeng/stepper';
import { CalendarModule } from 'primeng/calendar';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { InputMaskModule } from 'primeng/inputmask';
import { StudentsAssignSubscriptionComponent } from './students-assign-subscription/students-assign-subscription.component';
import { SubscriptionSelectorComponent } from './subscription-selector/subscription-selector.component';
import { TooltipModule } from 'primeng/tooltip';
import { InternalExamDialogComponent } from './internal-exam/internal-exam-dialog.component';
import { MenuModule } from 'primeng/menu';
import { DropdownModule } from 'primeng/dropdown';
import { AutoFocusModule } from 'primeng/autofocus';
import { AgreementPickerComponent } from '../../shared/components/agreement-picker/agreement-picker.component';
import { StudentAgreementsComponent } from './student-agreements/student-agreements.component';
import { StudentsInvitationsComponent } from './students-invitations/students-invitations.component';

@NgModule({
  declarations: [
    StudentsComponent,
    AddStudentComponent,
    StudentsDetailsComponent,
    InviteStudentComponent,
    ExamViewComponent,
    ExamDateComponent,
    SubscriptionSelectorComponent,
    StudentsListActiveComponent,
    StudentsListArchivedComponent,
    StudentsAssignSubscriptionComponent,
    InternalExamDialogComponent,
  ],
  imports: [
    StudentLecturesComponent,
    StudentAgreementsComponent,
    StudentsInvitationsComponent,
    AgreementPickerComponent,
    CommonModule,
    FasServiceDynamicTableComponent,
    TabViewModule,
    SubscriptionTagComponent,
    ButtonModule,
    StepperModule,
    InputTextModule,
    InputMaskModule,
    TooltipModule,
    MenuModule,
    DropdownModule,
    AutoFocusModule,

    FasServiceTableComponent,
    DialogModule,
    ReactiveFormsModule,
    FormsModule,
    InputNumberModule,
    CalendarModule,
    TableModule,

  ],
})
export class StudentsModule {}
